import React, { useState, useEffect } from "react";
import { Button, Whisper, Tooltip } from "rsuite";
import { numberFormatter, numberFormatterInK } from "../../utils";
// import EditIcon from "@rsuite/icons/Edit";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import ResetIcon from "@mui/icons-material/RestartAlt";
import TopSuppliersChart from "./topSuppliersChart";
import { CSVLink, CSVDownload } from "react-csv";
import TableTitle from "../../components/common/Table/TableTitle";
import FileDownloadIcon from "@rsuite/icons/FileDownload";

const SpendShift = (props: any) => {
	const [currentEdit, setCurrentEdit] = useState<Array<any>>([]);

	let csvHeaders = [
		{ label: "Tail End Suppliers", key: "tail_end_supplier" },
		{ label: " Spend ($)", key: "spend" },
	];

	{
		props.topSuppliersList.map((item: any) => {
			csvHeaders = [...csvHeaders, { label: item, key: item }];
		});
	}

	csvHeaders = [
		...csvHeaders,
		{ label: "Remaining Spend", key: "remainingSpend" },
	];

	const consolidationData = props.data;
	let consolidationDataExport = JSON.parse(JSON.stringify(consolidationData));
	consolidationDataExport.map((item: any, index: any) => {
		{
			props.topSuppliersList.map((d: any) => {
				item[d] = `${(item[d] * 100).toFixed(0)}%`;
			});
		}

		item.remainingSpend = `${(item.remainingSpend * 100).toFixed(0)}`;

		return item;
	});
	const kpi = props.kpiData;

	const validateNumbers = (e: any) => {
		return (e.target.value = e.target.value.replace(/[^\d]/g, ""));
	};

	return (
		<>
			<div className="topSuppliers-container contentBox  flex flex-col w-[50%]">
				{kpi == null || props.l3.length == 0 ? (
					<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
						Please select the L3 Category to see the relevant Top
						spend suppliers
					</div>
				) : (
					<>
						<div className="summary flex gap-2 w-full">
							<div className="card">
								<span className="header">
									Total Consolidation Opportunity
								</span>
								<div className="bottom">
									{numberFormatter(
										kpi.totalConsolidatedOpportunity,
										0,
										"$"
									)}
								</div>
							</div>
							<div className="card">
								<span className="header">Net NIA Benefit</span>
								<div className="bottom">
									{numberFormatter(kpi.netNIA, 1, "$")}
								</div>
							</div>
							<div className="card">
								<span className="header">
									Incremental Margin Benefit
								</span>
								<div className="bottom">
									{numberFormatter(
										kpi.incrementalMarginbenefit,
										1,
										"$"
									)}
								</div>
							</div>
							<div className="card">
								<span className="header">Total Benefits</span>
								<div className="bottom">
									{numberFormatter(
										kpi.incrementalMarginbenefit +
											kpi.netNIA,
										1,
										"$"
									)}
								</div>
							</div>
						</div>

						<div className="top-suppliers-chat border-[0.5px] border-lightGrey shadow-md bg-white">
							<div className="headSpace">
								<span className="headContent">
									{`Top Suppliers for ${props.l3}`}
								</span>
							</div>
							<div className="grow-1 basis-[85%] mt-[0.5em]">
								<TopSuppliersChart
									data={kpi.charts}
									incrementalBenefit={
										kpi.incrementByTopVendor
									}
								></TopSuppliersChart>
							</div>
							<div className="contentFooter">
								<div className="flex space-x-2 ml-auto pr-2">
									<div className="flex items-center">
										<div
											className="w-3 h-3 mr-1"
											style={{
												backgroundColor: "#012169",
											}}
										></div>
										<span
											className="text-[0.85em]"
											style={{ color: "#012169" }}
										>
											Additional Spend Opportunity
										</span>
									</div>
									<div className="flex items-center">
										<div
											className="w-3 h-3 mr-1"
											style={{
												backgroundColor: "#62B5E582",
											}}
										></div>
										<span
											className="text-[0.85em]"
											style={{ color: "#62B5E5" }}
										>
											Current Spend
										</span>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</div>

			<div className="spendConsolidation-container contentBox flex flex-col w-[50%]">
				{props.tableLoading ? (
					<div className="loaderCustom"></div>
				) : props.l3.length > 0 && consolidationData.length > 0 ? (
					<>
						<div className="common-table-header-row">
							<span className="common-table-header">
								Spend Consolidation of Tail end suppliers
							</span>
							<div className="buttonWrapper flex gap-2">
								<CSVLink
									data={consolidationDataExport}
									headers={csvHeaders}
									filename="spend_consolidation.csv"
									className="p-0"
									target="_blank"
								>
									<FileDownloadIcon
										color="black"
										className="text-fsre15"
									/>
								</CSVLink>
							</div>
						</div>
						{props.overSpendMsg && (
							<div className="italic errorMsg">
								*Distributed spend doesn't match with actual
								spend.
							</div>
						)}

						{consolidationData.length > 0 && (
							<>
								<table className="common-table-ui">
									<thead>
										<tr>
											<th rowSpan={2}>
												Tail End Suppliers
											</th>
											<th rowSpan={2}>Spend ($)</th>
											<th
												colSpan={
													props.topSuppliersList
														.length
												}
											>
												% Spend to be transitioned to
												top suppliers
											</th>

											<th rowSpan={2}>
												Remaining <br />
												Spend %
											</th>
											<th rowSpan={2}>Action</th>
										</tr>
										<tr>
											{props.topSuppliersList.map(
												(item: any) => {
													return (
														<th key={item}>
															{item}
														</th>
													);
												}
											)}
										</tr>
									</thead>
									<tbody>
										{consolidationData.length > 0 &&
											consolidationData.map(
												(d: any, index: any) => {
													return (
														<tr
															key={index}
															className={`${
																Number(
																	d.remainingSpend
																) < 0
																	? "colorRed"
																	: ""
															}`}
														>
															<td>
																{
																	d.tail_end_supplier
																}
															</td>
															<td>
																{numberFormatter(
																	d.spend,
																	0
																)}
															</td>

															{props.topSuppliersList.map(
																(item: any) => {
																	if (
																		currentEdit.includes(
																			index
																		)
																	) {
																		return (
																			<td
																				key={
																					item +
																					index
																				}
																			>
																				<input
																					type="text"
																					className="targetCostInput"
																					onInput={(
																						e
																					) => {
																						validateNumbers(
																							e
																						);
																					}}
																					defaultValue={(
																						d[
																							item
																						] *
																						100
																					).toFixed(
																						0
																					)}
																					onChange={(
																						e
																					) => {
																						props.handleChange(
																							e,
																							d[
																								item
																							],
																							d,
																							index,
																							item
																						);
																					}}
																				/>
																			</td>
																		);
																	} else {
																		return (
																			<td
																				key={
																					item +
																					index
																				}
																			>
																				{(
																					d[
																						item
																					] *
																					100
																				).toFixed(
																					0
																				)}

																				%
																			</td>
																		);
																	}
																}
															)}

															<td>
																<Whisper
																	placement="bottom"
																	speaker={
																		<Tooltip>
																			{(
																				d.remainingSpend *
																				100
																			).toFixed(
																				0
																			)}
																			{Math.abs(
																				d.remainingSpend
																			) >
																			0
																				? "%"
																				: ""}
																		</Tooltip>
																	}
																>
																	<span>
																		{Math.abs(
																			d.remainingSpend
																		) < 0
																			? "0%"
																			: (
																					d.remainingSpend *
																					100
																			  ).toFixed(
																					0
																			  )}
																		%
																	</span>
																</Whisper>
															</td>
															<td>
																<div className="flex justify-center items-center">
																	{!d.editable ? (
																		<EditIcon
																			className="cursor-pointer editIcon"
																			onClick={() => {
																				d.editable =
																					true;
																				setCurrentEdit(
																					[
																						...currentEdit,
																						index,
																					]
																				);
																			}}
																		/>
																	) : (
																		<>
																			<ResetIcon
																				className="cursor-pointer resetIcon"
																				onClick={() => {
																					d.editable =
																						false;
																					const ind =
																						currentEdit.indexOf(
																							index
																						);
																					if (
																						ind >
																						-1
																					) {
																						let r =
																							currentEdit;
																						r.splice(
																							ind,
																							1
																						);
																						setCurrentEdit(
																							[
																								...r,
																							]
																						);
																					}
																					props.handleReset(
																						d,
																						index
																					);
																				}}
																			/>
																			<SaveIcon
																				className={`cursor-pointer saveIcon ${
																					Number(
																						d.remainingSpend
																					) <
																					0
																						? "disabledIcon"
																						: ""
																				}`}
																				onClick={() => {
																					d.editable =
																						false;
																					const ind =
																						currentEdit.indexOf(
																							index
																						);
																					if (
																						ind >
																						-1
																					) {
																						let r =
																							currentEdit;
																						r.splice(
																							ind,
																							1
																						);
																						setCurrentEdit(
																							[
																								...r,
																							]
																						);
																					}
																					props.handleSave(
																						d,
																						index
																					);
																				}}
																			/>
																		</>
																	)}
																</div>
															</td>
														</tr>
													);
												}
											)}
									</tbody>
								</table>
							</>
						)}
					</>
				) : (
					<div className="h-full flex justify-center items-center italic text-[2.5vh] text-black font-normal">
						Please select the L3 Category to see the relevant Top
						spend suppliers
					</div>
				)}
			</div>
		</>
	);
};
export default SpendShift;
